import BaseModel from './base_model';
import librariesPopup from '../templates/popups/libraries';

export default class Library extends BaseModel {
	/**
	 * Represents a Library linked to the server API.
	 * @constructor
	 * @param {integer} id - The id for the Libraries API wrapper.
	 */
	constructor(id) {
		super();
		this.id = id;
		this.url = W.api_root + 'libraries' + '/' + id + '.json';
		this.key = 'Library_' + id;
		this.object_type = 'library';
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'map_objects/' + this.data.map_object_id + '.html';
	}

	popupContent() {
		this.setHtmlView();
		return librariesPopup(this);
	}
}
